var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.429,
    height: 51.73,
    viewBox: "0 0 51.429 51.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.399 -8.724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.399 8.724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.434 0.426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.57,13.605C29.419,8.624,19.9,10.181,14.313,17.083S9.179,33.618,15.33,38.6,31,42.023,36.588,35.121s5.133-16.535-1.018-21.516ZM24.829,39.286a4.464,4.464,0,0,1-4.919-3.925,4.464,4.464,0,0,1,4.463-4.436,4.464,4.464,0,0,1,4.919,3.925A4.464,4.464,0,0,1,24.829,39.286Z",
    transform: "translate(-10.402 -10.69)",
    fill: "#ffd112"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.16,40.412a13.634,13.634,0,0,1-8.67-3.015A13.93,13.93,0,0,1,8.417,27.042a17.448,17.448,0,0,1,3.99-11.772c5.731-7.077,15.54-8.666,21.867-3.542s6.812,15.049,1.082,22.126A17.449,17.449,0,0,1,24.672,40.2,15.549,15.549,0,0,1,22.16,40.412ZM25.588,9.589a16.313,16.313,0,0,0-12.507,6.227A16.581,16.581,0,0,0,9.284,27,12.824,12.824,0,0,0,24.532,39.349a16.583,16.583,0,0,0,10.151-6.04c5.43-6.705,5-16.083-.954-20.906a12.813,12.813,0,0,0-8.141-2.813Zm-2.617,28.6a4.865,4.865,0,0,1-5.062-4.342,4.9,4.9,0,0,1,4.872-4.893,4.9,4.9,0,0,1,5.376,4.334,4.9,4.9,0,0,1-4.872,4.893C23.179,38.185,23.075,38.188,22.971,38.188Zm.29-.441h0Zm-.166-7.935c-.088,0-.177,0-.266.007a4.038,4.038,0,0,0-4.053,3.98,4.038,4.038,0,0,0,4.462,3.515,4.038,4.038,0,0,0,4.053-3.98,4,4,0,0,0-4.2-3.522Z",
    transform: "translate(-8.399 -8.724)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.488 4.248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.798,
    cy: 2.798,
    r: 2.798,
    fill: "#4671c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.566 3.696)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.798,
    cy: 2.798,
    r: 2.798,
    fill: "#004377"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.109 7.67)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.798,
    cy: 2.798,
    r: 2.798,
    fill: "#4671c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.782 14.988)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.798,
    cy: 2.798,
    r: 2.798,
    fill: "#004377"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.723 19.656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.925,100.273a.946.946,0,0,0-.946-.893H137.254a.946.946,0,0,0-.946.893c-.186,3.407-.2,15.591,8.754,19.62a7.453,7.453,0,0,0,6.107,0c8.951-4.029,8.941-16.214,8.755-19.62Z",
    transform: "translate(-136.264 -99.38)",
    fill: "#ffe166"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.478 32.346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.645,161.132a3.224,3.224,0,0,1,6.448,0Z",
    transform: "translate(-176.645 -157.908)",
    fill: "#4671c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.777 23.308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.609,121.8a3.99,3.99,0,0,1-3.848-2.952.759.759,0,1,1,1.466-.392,2.465,2.465,0,0,0,4.762-1.276.759.759,0,0,1,1.466-.392,3.987,3.987,0,0,1-3.846,5.014Z",
    transform: "translate(-145.735 -116.224)",
    fill: "#4671c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.765 23.307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.171,116.782a.759.759,0,1,1,1.466.392,2.465,2.465,0,1,0,4.762,1.276.759.759,0,0,1,1.466.392,3.983,3.983,0,0,1-7.694-2.061Z",
    transform: "translate(-201.029 -116.219)",
    fill: "#4671c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.63 30.128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7,148.572a.946.946,0,0,0-.946-.893H63.03a.946.946,0,0,0-.946.893c-.186,3.407-.2,15.591,8.754,19.62a7.453,7.453,0,0,0,6.108,0C85.9,164.164,85.887,151.979,85.7,148.572Z",
    transform: "translate(-62.04 -147.679)",
    fill: "#ffe67e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.385 42.818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.868,206.208a3.224,3.224,0,0,1-6.448,0Z",
    transform: "translate(-102.42 -206.208)",
    fill: "#004377"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.985 34.559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.107,172.869h0a.759.759,0,0,1-.756-.762,2.468,2.468,0,0,0-2.456-2.473h-.009a2.468,2.468,0,0,0-2.465,2.456.759.759,0,0,1-.759.756h0a.759.759,0,0,1-.756-.762,3.988,3.988,0,0,1,3.983-3.969H76.9a3.987,3.987,0,0,1,3.969,4A.758.758,0,0,1,80.107,172.869Z",
    transform: "translate(-72.9 -168.116)",
    fill: "#004377"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.261 34.559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.667,172.857a.759.759,0,0,1-.759-.759,3.983,3.983,0,1,1,7.965,0,.759.759,0,0,1-1.518,0,2.465,2.465,0,0,0-4.93,0A.759.759,0,0,1,125.667,172.857Z",
    transform: "translate(-124.908 -168.115)",
    fill: "#004377"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.196 29.694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.325,167.714a7.872,7.872,0,0,1-3.232-.693c-9.152-4.12-9.21-16.38-9.009-20.04a1.38,1.38,0,0,1,1.378-1.3H83.187a1.38,1.38,0,0,1,1.378,1.3c.2,3.66.142,15.92-9.009,20.04A7.872,7.872,0,0,1,72.325,167.714ZM61.462,146.545a.512.512,0,0,0-.512.484c-.193,3.52-.149,15.308,8.5,19.2a7.009,7.009,0,0,0,5.751,0c8.648-3.893,8.692-15.681,8.5-19.2a.512.512,0,0,0-.512-.484Z",
    transform: "translate(-60.038 -145.678)",
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.c1e8a7a6c06d86c2064fa1c621a149f8.svg";
export { ForwardRef as ReactComponent };